import React, { useEffect } from "react";
import firebase from "../firebase";

import { makeStyles } from "@material-ui/core/styles";
import StarsRoundedIcon from "@material-ui/icons/StarsRounded";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  verifiedBadge: {
    color: theme.palette.warning.light,
    width: "18px",
    height: "18px",
    position: "relative",
    top: "4px",
    left: "3px",
    right: "3px",
    //verticalAlign: "middle",
    //lineHeight: 1,
    transition: theme.transitions.create(["transform"], {
      duration: theme.transitions.duration.complex,
      delay: 300,
    }),
    "&:hover": {
      transform: "rotate(720deg)",
    },
  },
  verifiedBadgeBig: {
    color: theme.palette.warning.light,
    width: "30px",
    height: "30px",
    position: "relative",
    top: "4px",
    left: "1px",
    right: "1px",
    //verticalAlign: "middle",
    //lineHeight: 1,
    transition: theme.transitions.create(["transform"], {
      duration: theme.transitions.duration.complex,
      delay: 300,
    }),
    "&:hover": {
      transform: "rotate(720deg)",
    },
  },
}));

const DoctorBadge = (props) => {
  const classes = useStyles();
  const [user, setUser] = React.useState({});

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const snapshot = await firebase
      .database()
      .ref(`users/${props.id}`)
      .once("value");
    setUser({ id: snapshot.key, ...snapshot.val() });
  };

  return user && user.isVerified ? (
    <span>
      <Tooltip
        title="This user is a verified doctor!"
        enterDelay={300}
        leaveDelay={200}
        enterNextDelay={300}
      >
        <StarsRoundedIcon
          className={
            props.type === "BIG"
              ? classes.verifiedBadgeBig
              : classes.verifiedBadge
          }
        />
      </Tooltip>
    </span>
  ) : null;
};

export default DoctorBadge;
